var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:("bundle bundle-" + _vm.color)},[_vm._v(" "+_vm._s(_vm.$t(("voice.call.status." + _vm.value)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }